module.exports = __webpack_public_path__ + "static/media/LM-LOGO-TOPTAB.24e04088.svg";